import { HotelsRelinking } from './HotelsRelinking';

export default HotelsRelinking;
